import http from '../tools/Http';

/**
 * 
 * 用户登录接口
 * **/
export function userlogin(params){
    return http({
        url:"/admin/login",
        method:'post',
        params
    })
}

/**
 * 
 * 酒店注册接口
 * **/
export function storeRegister(params){
    return http({
        url:"/store/register",
        method:'post',
        params
    })
}

//获取验证码
export function getverifycode(verifycodeid){
    return http({
        url:"/admin/getverifycode",
        method:'post',
        params:{verifyId:verifycodeid}
    })
}

/***
 * 
 * 用户信息模块
 */

//查询用户信息
export function getUserInfo(){
    return http({
        url:"/user/userinfo",
        method:'get'
    })
}

//修改用户信息
export function updateUserInfo(params){
    return http({
        url:"/user/updateuserinfo",
        method:'post',
        params
    })
}

//菜单模块
export function selectRouteList(){
    return http({
        url:"/menu/findallmenu",
        method:'get'
    })
}

export function selectNavList(){
    return http({
        url:"/menu/navlist",
        method:'get'
    })
}

//获取菜单控件
export function findMenuContrByMenuId(menuId){
    return http({
        url:"/menu/findmenucontrbymenuId",
        method:'post',
        params:{menuId:menuId}
    })
}

/***
 * 
 * 酒店信息模块
 */

//获取酒店信息
export function selectStoreInfo(){
    return http({
        url:"/store/select",
        method:'get'
    })
}
//获取酒店类型
export function selectStoreType(){
    return http({
        url:"/store/gettype",
        method:'get'
    })
}
//修改酒店信息
export function updateStoreInfo(params){ 
    return http({
        url:"/store/update",
        method:'post',
        params
    })
}
//修改酒店状态
export function updateStoreStatus(params){ 
    return http({
        url:"/store/updatestatus",
        method:'post',
        params
    })
}
//查询酒店订单统计
export function selectOrderStatistics(){ 
    return http({
        url:"/store/orderstatistics",
        method:'get'
    })
}
//查询商家收益
export function selectStoreRevenue(){ 
    return http({
        url:"/store/revenue",
        method:'get'
    })
}
//查询商家交易明细
export function selectAcctNobook(params){ 
    return http({
        url:"/store/acctnobook",
        method:'get',
        params
    })
}
//查询商家交易明细（分页）
export function selectAcctNobookPage(params){ 
    return http({
        url:"/store/acctnobook",
        method:'get',
        params
    })
}
//获取酒店图片类型
export function selectStorePicType(){
    return http({
        url:"/store/getpictype",
        method:'get'
    })
}

//获取图片列表
export function selectStorePicList(type){ 
    return http({
        url:"/store/getpiclist",
        method:'get',
        params:{
            storePicType:type
        }
    })
}
//添加图片
export function addStorePic(params){ 
    return http({
        url:"/store/addpic",
        method:'post',
        params
    })
}
//删除图片
export function deleteStorePic(id){ 
    return http({
        url:"/store/deletepic",
        method:'post',
        params:{
            storePicId:id
        }
    })
}

/***
 * 
 * 房间模块
 */

//获取房间列表
export function selectRoomListPage(params){
    return http({
        url:"/room/pagelist",
        method:'get',
        params
    })
}
//
export function selectRoomById(params){ 
    return http({
        url:"/room/selectbyid",
        method:'get',
        params
    })
}

export function updateRoom(params){ 
    return http({
        url:"/room/update",
        method:'post',
        params
    })
}

export function addRoom(params){ 
    return http({
        url:"/room/insert",
        method:'post',
        params
    })
}

export function deleteRoom(id){ 
    return http({
        url:"/room/delete",
        method:'post',
        params:{
            roomId:id
        }
    })
}

export function updateRoomState(params){ 
    return http({
        url:"/room/updateStatus",
        method:'post',
        params
    })
}

/***
 * 
 * 订单模块
 */

//获取订单列表（分页）
export function selectOrderListPage(params){
    return http({
        url:"/order/pagelist",
        method:'get',
        params
    })
}

//获取订单详情
export function getOrderDetail(id){
    return http({
        url:"/order/selectbyid",
        method:'get',
        params:{orderId:id}
    })
}


//确认订单
export function confirmOrder(id){
    return http({
        url:"/order/confirm",
        method:'post',
        params:{orderId:id}
    })
}

//办理入住
export function checkinOrder(id){
    return http({
        url:"/order/checkin",
        method:'post',
        params:{orderId:id}
    })
}

//办理退房
export function checkoutOrder(id){
    return http({
        url:"/order/checkout",
        method:'post',
        params:{orderId:id}
    })
}

//商家取消订单
export function cancelOrder(params){
    return http({
        url:"/order/cancel",
        method:'post',
        data:params,
        headers:{
            'Content-Type':'application/json'
        }
    })
}

/***
 * 
 * 员工管理模块
 */

//获取员工列表（分页）
export function selectEmployeeList(params){
    return http({
        url:"/user/list",
        method:'get',
        params
    })
}

//获取用户角色列表
export function selectRoleList(){
    return http({
        url:"/user/rolelist",
        method:'get'
    })
}

//添加员工
export function addEmployee(params){
    return http({
        url:"/user/adduser",
        method:'post',
        params
    })
}

//修改员工信息
export function updateEmployee(params){
    return http({
        url:"/user/updatestoreuser",
        method:'post',
        params
    })
}

//注销员工
export function cancelEmployee(storeUid){
    return http({
        url:"/user/cancel",
        method:'post',
        params:{storeUid:storeUid}
    })
}